import Controller from "controllers/application_controller"

export default class extends Controller {
  static identifier = "ui-filter"
  static values = {
    key: String
  }

  connect() {
    this.addEventListener(this.element, "change", event => this.handleChange(event))
    this.addEventListener(this.element, "input", event => this.handleChange(event))
  }

  remove(event) {
    event?.preventDefault()

    const key = this.keyValue
    const parent = this.element.parentElement
    this.element.remove()

    parent?.dispatchEvent(new CustomEvent("filter:remove", {
      detail: { key },
      bubbles: true
    }))
  }

  focusInput() {
    const candidates = this.element.querySelectorAll(
      ".ui-filter__body :where(input, button, select, textarea):not(.ui-filter__op-native)"
    )
    const target = [...candidates].find(el => el.offsetParent !== null)
    if (!target) return

    target.focus()

    if (target.tagName === "BUTTON") {
      target.click()
      return
    }

    try { target.showPicker?.() } catch {}
  }

  handleChange({ target }) {
    // The blank prompt option means "any" — semantically the same as not
    // filtering at all, so picking it removes the filter.
    if (target.matches(".ui-filter__select-native") && target.value === "") {
      this.remove()
      return
    }

    this.dispatch("change", {
      prefix: "filter",
      bubbles: true,
      detail: { key: this.keyValue }
    })
  }
}
